import { useState, useEffect } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginUserAction } from "redux/slice/users";
import { enqueueSnackbar } from "notistack";

axios.defaults.withCredentials = true;

const BASE_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create();

export const getAPICall = (url, header, params) =>
  new Promise((resolve, reject) => {
    if (header) {
      axiosInstance
        .get(`${BASE_URL}/${url}`, {
          params,
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    } else {
      axios
        .get(`${BASE_URL}/${url}`)
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    }
  });

export const postAPICall = (url, header, body, headersConfig = {}) =>
  new Promise((resolve, reject) => {
    if (header) {
      axiosInstance
        .post(`${BASE_URL}/${url}`, body, {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            ...headersConfig,
          },
        })
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    } else {
      axios
        .post(`${BASE_URL}/${url}`, body)
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    }
  });

export const putAPICall = (url, header, body) =>
  new Promise((resolve, reject) => {
    if (header) {
      axiosInstance
        .put(`${BASE_URL}/${url}`, body, {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    } else {
      axios
        .put(`${BASE_URL}/${url}`, body)
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    }
  });

export const deleteAPICall = (url, header, params) =>
  new Promise((resolve, reject) => {
    if (header) {
      axiosInstance
        .delete(`${BASE_URL}/${url}`, {
          params,
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    } else {
      axios
        .delete(`${BASE_URL}/${url}`, {
          params,
        })
        .then((result) => resolve(result))
        .catch((error) => reject(error));
    }
  });

export const AxiosInterceptor = ({ children }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isSnackbarShown, setIsSnackbarShown] = useState(false);
  const [errorMessageForSnackbar, setErrorMessageForSnackbar] = useState("");
  const loginUser = useSelector((state) => state.loginUser.loginUserState);

  useEffect(() => {
    if (loginUser?.id) {
      setIsSnackbarShown(false);
      setErrorMessageForSnackbar(false);
    }
  }, [loginUser]);

  useEffect(() => {
    if (isSnackbarShown) {
      enqueueSnackbar(
        JSON.stringify({
          icon: "error",
          title: "Session Expired",
          text: errorMessageForSnackbar || "",
        }),
        {
          variant: "custom",
        }
      );
    }
  }, [isSnackbarShown]);

  const handleLogout = (err) => {
    setErrorMessageForSnackbar(err?.response?.data?.message || "");
    setIsSnackbarShown((prevState) => {
      if (!prevState) return true;
      return prevState;
    });

    localStorage.clear();
    dispatch(loginUserAction.logoutUser());
    navigate("/sign-in");
  };

  axiosInstance.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err?.response?.status === 403) {
        handleLogout(err);
      }
      return err;
    }
  );

  return children;
};
